/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsOverview} from '../api'

 export const useQueryGetSavingsOverview = createReactQueryHook('getSavingsOverview', getSavingsOverview)
